import { gql } from "@apollo/client";

export const CREATE_OR_UPDATE_HSC_TRACKING = gql`
mutation CreateOrUpdateHscTracking($input: [HscTrackingInput]) {
  createOrUpdateHscTracking(input: $input) {
    success
    message
    error
    data {
      arcimedes_row_id
      property_id
      deleted
      task
      quote_sent_to_borrower
      quote_sent_to_borrower_checkbox
      hsc_agreement_sent
      hsc_agreement_sent_checkbox
      hsc_agreement_signed
      hsc_agreement_signed_checkbox
      collect_borrower_documents_requested
      collect_borrower_documents_requested_checkbox
      collect_borrower_documents_received
      collect_borrower_documents_received_checkbox
      collect_borrower_documents_outstanding
      term_sheet_sent
      term_sheet_sent_checkbox
      term_sheet_signed
      term_sheet_signed_checkbox
      deposit_received
      deposit_received_checkbox
      order_3rd_parties
      order_3rd_parties_checkbox
      order_3rd_parties_phase_i
      order_3rd_parties_phase_i_checkbox
      order_3rd_parties_phase_i_due_date
      order_3rd_parties_phase_i_due_date_checkbox
      order_3rd_parties_appraisal
      order_3rd_parties_appraisal_checkbox
      order_3rd_parties_appraisal_due_date
      order_3rd_parties_appraisal_due_date_checkbox
      loan_committee
      loan_committee_checkbox
      loan_committee_approved
      estoppel_snda_sent
      estoppel_snda_sent_checkbox
      estoppel_snda_received
      estoppel_snda_received_checkbox
      loan_docs
      loan_docs_checkbox
      sent_invoice_wire_instructions
      sent_invoice_wire_instructions_checkbox
      close_of_escrow
      close_of_escrow_checkbox
      title_company
      escrow_officer
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
  }
}
`